import React, { Component } from "react";
import PropTypes from "prop-types";
import {
  Container,
  Row,
  Col,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Table,
  Input,
  Nav,
  NavItem,
  Dropdown,
  DropdownItem,
  DropdownToggle,
  DropdownMenu,
  NavLink,
} from "reactstrap";
import ApexRadial from "./ApexRadialleft";
import ApexRadialright from "./ApexRadialright";
import BootstrapTable from "react-bootstrap-table-next";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import "./dashboard.css";

//import Charts
import StackedColumnChart from "./StackedColumnChart";

import modalimage1 from "../../assets/images/product/img-7.png";
import modalimage2 from "../../assets/images/product/img-4.png";

//import action
import { getChartsData } from "../../store/actions";

// Pages Components
import WelcomeComp from "./WelcomeComp";
import MonthlyEarning from "./MonthlyEarning";
import SocialSource from "./SocialSource";
import ActivityComp from "./ActivityComp";
import TopCities from "./TopCities";
import LatestTranaction from "./LatestTranaction";

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";
import moment from "moment/moment";
//i18n
import { withTranslation } from "react-i18next";
import classNames from "classnames";
import {
  baseUrl,
  getDashboardPaymentAPI,
  getPaymentAPI,
  getRemainderAPI,
  getStocksDashboard,
} from "api";

class Dashboard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      remainderDetailList: [],
      paymentDetailList: [],
      reports: [
        { title: "Orders", iconClass: "bx-copy-alt", description: "1,235" },
        {
          title: "Revenue",
          iconClass: "bx-archive-in",
          description: "$35, 723",
        },
        {
          title: "Average Price",
          iconClass: "bx-purchase-tag-alt",
          description: "$16.2",
        },
      ],
      email: [
        { title: "Week", linkto: "#", isActive: false },
        { title: "Month", linkto: "#", isActive: false },
        { title: "Year", linkto: "#", isActive: true },
      ],
      modal: false,
      subscribemodal: false,
      chartSeries: [],
      periodType: "yearly",
      dashboard: "",
    };

    this.togglemodal.bind(this);
    this.togglesubscribemodal.bind(this);
  }

  async componentDidMount() {
    const payment = await getDashboardPaymentAPI({
      page: 1,
      limit: 5,
    });
    if(payment){
      this.setState({
        paymentDetailList: payment.data,
      });
    }
    const remainder = await getRemainderAPI({ page: null, limit: null });
    if(remainder){
      this.setState({
        remainderDetailList: remainder.data,
      });
    }
    const { onGetChartsData } = this.props;
    onGetChartsData("yearly");
    const data = await getStocksDashboard();
    this.setState({
      dashboard: data.data,
    });
  }

  togglemodal = () => {
    this.setState(prevState => ({
      modal: !prevState.modal,
    }));
  };

  togglesubscribemodal = () => {
    this.setState(prevState => ({
      subscribemodal: !prevState.subscribemodal,
    }));
  };

  componentDidUpdate(prevProps) {
    if (prevProps !== this.props) {
      this.setState({ ...this.state, chartSeries: this.props.chartsData });
    }
  }

  render() {
    //meta title
    document.title = "dashboard";
    this.columns1 = [
      {
        dataField: "id",
        text: `${this.props.t("ID")}`,
        hidden: true,
      },
      {
        dataField: "srNo",
        text: `${this.props.t("Sr.No")}`,
        formatter: (cell, row, rowIndex) => {
          return rowIndex + 1;
        },
      },
      {
        dataField: "partyName",
        text: `${this.props.t("Party Name")}`,
        formatter: (cell, row, rowIndex) => {
          return row.ledger?.party?.name;
        },
      },
      {
        dataField: "paymentStatus",
        text: `${this.props.t("Payment Status")}`,
        formatter: (cell, row, rowIndex) => {
          return row.ledger?.paymentStatus;
        },
      },
      {
        dataField: "paymentMethod",
        text: `${this.props.t("Payment Method")}`,
        formatter: (cell, row) => {
          if (cell == 1) {
            return "Cash";
          } else if (cell == 2) {
            return "Cheque";
          } else {
            return "RTGS & UPI";
          }
        },
      },
      {
        dataField: "payDate",
        text: `${this.props.t("Payment Date")}`,
        formatter: (cell, row) => {
          return moment(cell).format("DD-MM-YYYY");
        },
      },
      {
        dataField: "amount",
        text: `${this.props.t("Payment Amount")}`,
      },
      {
        dataField: "remainingAmount",
        text: `${this.props.t("Remaining Amount")}`,
      },
      // {
      //   dataField: "viewDetail",
      //   text: `${this.props.t("View Details")}`,
      //   formatter: (cell, row) => (
      //     <div className="btn-group">
      //       <button
      //         type="button"
      //         onClick={() => {}}
      //         className="py-2 px-2 border-0 rounded ms-2"
      //       >
      //         <img src="images/dashboard-images/edit.svg" />
      //       </button>
      //       <button type="button" className="py-2 px-2 border-0 rounded ms-2">
      //         <img src="images/dashboard-images/view.svg" />
      //       </button>
      //     </div>
      //   ),
      // },
    ];

    this.columns2 = [
      {
        dataField: "id",
        text: `${this.props.t("ID")}`,
        hidden: true,
      },
      {
        dataField: "srNo",
        text: `${this.props.t("Sr.No")}`,
        hidden: true,
      },
      {
        dataField: "ledgerId",
        text: `${this.props.t("Ledger Id")}`,
      },
      {
        dataField: "partyName",
        text: `${this.props.t("Party Name")}`,
        formatter: (cell, row, rowIndex) => {
          return row.ledger?.party?.name;
        },
      },
      {
        dataField: "notes",
        text: `${this.props.t("Notes")}`,
      },
      {
        dataField: "date",
        text: `${this.props.t("Date")}`,
        formatter: (cell, row) => {
          return moment(cell).format("DD-MM-YYYY");
        },
      },
      {
        dataField: "time",
        text: `${this.props.t("Remainder Time")}`,
      },
      {
        dataField: "ledgerTime",
        text: `${this.props.t("Ledger Time")}`,
        formatter: (cell, row) => {
          return moment(row.ledger.createdAt).format("DD-MM-YYYY");
        },
      },
      // {
      //   dataField: "viewDetail",
      //   text: `${this.props.t("View Details")}`,
      //   formatter: (cell, row) => (
      //     <div className="btn-group">
      //       <Link
      //         to={{
      //           pathname: "/",
      //           query: {
      //             isEdit: 2,
      //             data: row,
      //           },
      //         }}
      //       >
      //         <button className="py-2 px-2 border-0 rounded">
      //           <img src="images/dashboard-images/edit.svg" />
      //         </button>
      //       </Link>
      //     </div>
      //   ),
      // },
    ];

    return (
      <React.Fragment>
        <div className="page-content">
          <Row>
            <Breadcrumbs
              title={this.props.t("Dashboards")}
              breadcrumbItem={this.props.t("Dashboard")}
            />
            <Col xxl={2} lg={3}>
              <div className="bg-light-purple position-relative main_hero_section main_hero_section_sub py-lg-5 py-0">
                <Row className="ps-2">
                  <Col sm={8}>
                    <div className="pt-1">
                      <h3 className="text-black">
                      {this.props.t("Welcome Back")} !
                      </h3>
                    </div>
                  </Col>
                  <Col sm={4}>
                    <img
                      src={JSON.parse(localStorage.getItem("authUser")).photo == null ? `images/dashboard-images/welcome.svg` : `${baseUrl}/uploads/${JSON.parse(localStorage.getItem("authUser")).photo}`}
                      className="img-fluid mt-3"
                      alt="welcome image"
                    />
                  </Col>
                  <p className="text-secondary">Admin Dashboard</p>
                </Row>
                <div className="bg-white main_hero_section_sub w-100 mt-2 absolute ms-0 py-4 px-2">
                  <h4 className="text-black">{JSON.parse(localStorage.getItem("authUser")).name}</h4>
                  <p className="text-secondary">Admin</p>
                  <button className="main_hero_section_sub_btn">
                    View Profile{" "}
                    <i className="fa-solid fa-arrow-right-long"></i>
                  </button>
                </div>
              </div>
            </Col>
            <Col xxl={10} lg={9}>
              <Row>
                <Col lg={3}>
                  <div className="bg-white main_hero_section_sub mt-4 mt-lg-0 py-4 px-2">
                    <Row>
                      <Col sm={8} className="px-3">
                        <h5 className="pt-3 text-black fs-4">
                          {this.props.t("Daily Inward")}
                        </h5>
                        <h3 className="pt-2 text-black">
                          {this.state.dashboard.dailyInwards}
                        </h3>
                      </Col>
                      <Col sm={4}>
                        <img
                          src="images/dashboard-images/dailyinward.svg"
                          className="img-fluid"
                          alt="daily inward image"
                        />
                      </Col>
                    </Row>
                  </div>
                  <div className="bg-white main_hero_section_sub py-4 mt-4 px-2">
                    <Row>
                      <Col sm={8} className="px-3">
                        <h5 className="pt-3 text-black fs-4">{this.props.t("Daily Inward")}</h5>
                        <h3 className="pt-2 text-black">
                          {this.state.dashboard.dailyOutwards}
                        </h3>
                      </Col>
                      <Col sm={4}>
                        <img
                          src="images/dashboard-images/dailyoutward.svg"
                          className="img-fluid"
                          alt="daily outward image"
                        />
                      </Col>
                    </Row>
                  </div>
                </Col>
                <Col lg={3}>
                  <div className="bg-white main_hero_section_sub mt-4 mt-lg-0 py-4 px-2">
                    <Row>
                      <Col sm={8} className="px-3">
                        <h5 className="pt-3 text-black fs-4">{this.props.t("Weekly Inward")}</h5>
                        <h3 className="pt-2 text-black">
                          {this.state.dashboard.weeklyInwards}
                        </h3>
                      </Col>
                      <Col sm={4}>
                        <img
                          src="images/dashboard-images/dailyinward.svg"
                          className="img-fluid"
                          alt="daily inward image"
                        />
                      </Col>
                    </Row>
                  </div>
                  <div className="bg-white main_hero_section_sub py-4 mt-4 px-2">
                    <Row>
                      <Col sm={8} className="px-3">
                        <h5 className="pt-3 text-black fs-4">{this.props.t("Weekly Outward")}</h5>
                        <h3 className="pt-2 text-black">
                          {this.state.dashboard.weeklyOutwards}
                        </h3>
                      </Col>
                      <Col sm={4}>
                        <img
                          src="images/dashboard-images/dailyoutward.svg"
                          className="img-fluid"
                          alt="daily outward image"
                        />
                      </Col>
                    </Row>
                  </div>
                </Col>
                <Col lg={3}>
                  <div className="bg-white main_hero_section_sub mt-4 mt-lg-0 py-4 px-2">
                    <Row>
                      <Col sm={8} className="px-3">
                        <h5 className="pt-3 text-black fs-4">{this.props.t("Monthly Inward")}</h5>
                        <h3 className="pt-2 text-black">
                          {this.state.dashboard.monthlyInwards}
                        </h3>
                      </Col>
                      <Col sm={4}>
                        <img
                          src="images/dashboard-images/dailyinward.svg"
                          className="img-fluid"
                          alt="daily inward image"
                        />
                      </Col>
                    </Row>
                  </div>
                  <div className="bg-white main_hero_section_sub py-4 mt-4 px-2">
                    <Row>
                      <Col sm={8} className="px-3">
                        <h5 className="pt-3 text-black fs-4">
                        {this.props.t("Monthly Outward")}
                        </h5>
                        <h3 className="pt-2 text-black">
                          {this.state.dashboard.monthlyOutwards}
                        </h3>
                      </Col>
                      <Col sm={4}>
                        <img
                          src="images/dashboard-images/dailyoutward.svg"
                          className="img-fluid"
                          alt="daily outward image"
                        />
                      </Col>
                    </Row>
                  </div>
                </Col>
                <Col lg={3}>
                  <div className="bg-white main_hero_section_sub mt-4 mt-lg-0 py-4 px-2">
                    <Row>
                      <Col sm={8} className="px-3">
                        <h5 className="pt-3 text-black fs-4">{this.props.t("Yearly Inward")}</h5>
                        <h3 className="pt-2 text-black">
                          {this.state.dashboard.yearlyInwards}
                        </h3>
                      </Col>
                      <Col sm={4}>
                        <img
                          src="images/dashboard-images/dailyinward.svg"
                          className="img-fluid"
                          alt="daily inward image"
                        />
                      </Col>
                    </Row>
                  </div>
                  <div className="bg-white main_hero_section_sub py-4 mt-4 px-2">
                    <Row>
                      <Col sm={8} className="px-3">
                        <h5 className="pt-3 text-black fs-4">{this.props.t("Yearly Outward")}</h5>
                        <h3 className="pt-2 text-black">
                          {this.state.dashboard.yearlyOutwards}
                        </h3>
                      </Col>
                      <Col sm={4}>
                        <img
                          src="images/dashboard-images/dailyoutward.svg"
                          className="img-fluid"
                          alt="daily outward image"
                        />
                      </Col>
                    </Row>
                  </div>
                </Col>
              </Row>
            </Col>
          </Row>
          <Row className="mt-5">
            <Col xl={6} lg={12}>
              <div className="bg-white pt-3 pb-5 px-0 px-sm-5 text-center text-xxl-start rounded">
                <Row>
                  <Col xxl={5} xl={12} md={5} sm={12} className="mt-3 mt-xl-0">
                    <h3 className="pt-3 text-black fw-bold">{this.props.t("Payment Receive")}</h3>
                    <Nav
                      pills
                      className="d-flex justify-content-around mt-3 mt-lg-4"
                    >
                      <NavItem>
                        <NavLink href="#">Cash</NavLink>
                      </NavItem>
                      <NavItem>
                        <NavLink href="#">UPI</NavLink>
                      </NavItem>
                    </Nav>
                    <Row>
                      <Col xxl={3} sm={5} className="pt-0 pt-md-2">
                        <p className="text-success fs-4 pt-4 d-inline-block">
                          12% <i className="fa-solid fa-arrow-up-long"></i>
                        </p>
                      </Col>
                      <Col xxl={7} sm={7} className="pt-0 pt-md-2">
                        <p className="fs-5 text-secondary pt-0 pt-sm-4 d-inline-block ps-3">
                          From previous period
                        </p>
                      </Col>
                    </Row>
                    <button className="px-4 border-0 rounded mt-4 text-white bg-blue fs-4 py-2">
                      View Details
                    </button>
                  </Col>
                  <Col
                    xxl={{ offset: 1, size: 6 }}
                    xl={12}
                    md={{ size: 6 }}
                    sm={12}
                    className="mt-3 mt-lg-5 text-center"
                  >
                    <h1 className="text-black">₹5,45,897.56</h1>
                    <ApexRadial />
                  </Col>
                </Row>
              </div>
            </Col>
            <Col xl={6} lg={12} className="mt-5 mt-xl-0">
              <div className="bg-white pt-3 pb-5 px-0 px-sm-5 text-center text-xxl-start rounded">
                <Row>
                  <Col xxl={5} xl={12} md={5} sm={12} className="mt-3 mt-xl-0">
                    <h3 className="text-black fw-bold pt-3">{this.props.t("Payment Pending")}</h3>
                    <Nav
                      pills
                      className="d-flex justify-content-around mt-3 mt-lg-4"
                    >
                      <NavItem>
                        <NavLink href="#">Cash</NavLink>
                      </NavItem>
                      <NavItem>
                        <NavLink href="#">UPI</NavLink>
                      </NavItem>
                    </Nav>
                    <Row>
                      <Col xxl={3} sm={5} className="pt-0 pt-md-2">
                        <p className="text-success fs-4 pt-4  d-inline-block">
                          12% <i className="fa-solid fa-arrow-up-long"></i>
                        </p>
                      </Col>
                      <Col xxl={7} sm={7} className="pt-0 pt-md-2">
                        <p className="fs-5 text-secondary pt-0 pt-sm-4 d-inline-block ps-3">
                          From previous period
                        </p>
                      </Col>
                    </Row>
                    <button className="px-4 border-0 rounded mt-4 text-white bg-blue fs-4 py-2">
                      View Details
                    </button>
                  </Col>
                  <Col
                    xxl={{ offset: 1, size: 6 }}
                    xl={12}
                    md={{ size: 6 }}
                    sm={12}
                    className="mt-3 mt-lg-5 text-center"
                  >
                    <h1 className="text-black">₹1,25,022.56</h1>
                    <ApexRadialright />
                  </Col>
                </Row>
              </div>
            </Col>
          </Row>
          <Row className="mt-5 px-0 px-sm-3">
            <div className="bg-white py-3">
              <h2>{this.props.t('Latest Transaction')}</h2>
              <div className="table-responsive">
                <BootstrapTable
                  keyField="id"
                  responsive
                  bordered={false}
                  striped={false}
                  bootstrap4={true}
                  data={this.state.paymentDetailList}
                  columns={this.columns1}
                />
              </div>
            </div>
          </Row>
          <Row className="mt-5 px-0 px-sm-3">
            <div className="bg-white py-3">
              <h2>{this.props.t('Remainders')}</h2>
              <div className="table-responsive">
                <BootstrapTable
                  keyField="id"
                  responsive
                  bordered={false}
                  striped={false}
                  bootstrap4={true}
                  data={this.state.remainderDetailList}
                  columns={this.columns2}
                />
              </div>
            </div>
          </Row>
          <Container fluid>
            {/* Render Breadcrumb */}

            <Row>
              <Col xl="4">
                {/* <WelcomeComp /> */}
                {/* <MonthlyEarning /> */}
              </Col>
              <Col xl="8">
                {/* <Row>
                  Reports Render
                  {this.state.reports.map((report, key) => (
                    <Col md="4" key={"_col_" + key}>
                      <Card className="mini-stats-wid">
                        <CardBody>
                          <div className="d-flex">
                            <div className="flex-grow-1">
                              <p className="text-muted fw-medium">
                                {report.title}
                              </p>
                              <h4 className="mb-0">{report.description}</h4>
                            </div>
                            <div className="mini-stat-icon avatar-sm rounded-circle bg-primary align-self-center">
                              <span className="avatar-title">
                                <i
                                  className={
                                    "bx " + report.iconClass + " font-size-24"
                                  }
                                />
                              </span>
                            </div>
                          </div>
                        </CardBody>
                      </Card>
                    </Col>
                  ))}
                </Row> */}

                {/* <Card>
                  <CardBody>
                    <div className="d-sm-flex flex-wrap">
                      <CardTitle className="card-title mb-4 h4">
                        Email Sent
                      </CardTitle>
                      <div className="ms-auto">
                        <ul className="nav nav-pills">
                          <li className="nav-item">
                            <Link
                              to="#"
                              className={classNames(
                                { active: this.state.periodType === "weekly" },
                                "nav-link"
                              )}
                              onClick={() => {
                                this.setState({
                                  ...this.state,
                                  periodType: "weekly",
                                });
                                this.props.onGetChartsData("weekly");
                              }}
                              id="one_month"
                            >
                              Week
                            </Link>{" "}
                          </li>
                          <li className="nav-item">
                            <Link
                              to="#"
                              className={classNames(
                                { active: this.state.periodType === "monthly" },
                                "nav-link"
                              )}
                              onClick={() => {
                                this.setState({
                                  ...this.state,
                                  periodType: "monthly",
                                });
                                this.props.onGetChartsData("monthly");
                              }}
                              id="one_month"
                            >
                              Month
                            </Link>
                          </li>
                          <li className="nav-item">
                            <Link
                              to="#"
                              className={classNames(
                                { active: this.state.periodType === "yearly" },
                                "nav-link"
                              )}
                              onClick={() => {
                                this.setState({
                                  ...this.state,
                                  periodType: "yearly",
                                });
                                this.props.onGetChartsData("yearly");
                              }}
                              id="one_month"
                            >
                              Year
                            </Link>
                          </li>
                        </ul>
                      </div>
                    </div>
                    <div className="clearfix" />
                    <StackedColumnChart chartSeries={this.state.chartSeries} />
                  </CardBody>
                </Card> */}
              </Col>
            </Row>

            <Row>
              <Col xl="4">{/* <SocialSource /> */}</Col>
              <Col xl="4">{/* <ActivityComp /> */}</Col>
              <Col xl="4">{/* <TopCities /> */}</Col>
            </Row>
            <Row>
              <Col lg="12">{/* <LatestTranaction /> */}</Col>
            </Row>
          </Container>
        </div>

        <Modal
          isOpen={this.state.subscribemodal}
          role="dialog"
          autoFocus={true}
          data-toggle="modal"
          centered
          toggle={this.togglesubscribemodal}
        >
          <div className="modal-content">
            <div className="modal-header border-bottom-0">
              <button
                type="button"
                className="btn-close"
                onClick={() => this.setState({ subscribemodal: false })}
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body">
              <div className="text-center mb-4">
                <div className="avatar-md mx-auto mb-4">
                  <div className="avatar-title bg-light  rounded-circle text-primary h1">
                    <i className="mdi mdi-email-open"></i>
                  </div>
                </div>

                <div className="row justify-content-center">
                  <div className="col-xl-10">
                    <h4 className="text-primary">Subscribe !</h4>
                    <p className="text-muted font-size-14 mb-4">
                      Subscribe our newletter and get notification to stay
                      update.
                    </p>

                    <div className="input-group  rounded bg-light">
                      <Input
                        type="email"
                        className="form-control bg-transparent border-0"
                        placeholder="Enter Email address"
                      />
                      <Button color="primary" type="button" id="button-addon2">
                        <i className="bx bxs-paper-plane"></i>
                      </Button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Modal>

        <Modal
          isOpen={this.state.modal}
          role="dialog"
          autoFocus={true}
          centered={true}
          className="exampleModal"
          tabindex="-1"
          toggle={this.togglemodal}
        >
          <div className="modal-content">
            <ModalHeader toggle={this.togglemodal}>Order Details</ModalHeader>
            <ModalBody>
              <p className="mb-2">
                Product id: <span className="text-primary">#SK2540</span>
              </p>
              <p className="mb-4">
                Billing Name:{" "}
                <span className="text-primary">Neal Matthews</span>
              </p>

              <div className="table-responsive">
                <Table className="table align-middle table-nowrap">
                  <thead>
                    <tr>
                      <th scope="col">Product</th>
                      <th scope="col">Product Name</th>
                      <th scope="col">Price</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <th scope="row">
                        <div>
                          <img src={modalimage1} alt="" className="avatar-sm" />
                        </div>
                      </th>
                      <td>
                        <div>
                          <h5 className="text-truncate font-size-14">
                            Solid Color T-Shirt
                          </h5>
                          <p className="text-muted mb-0">$ 225 x 1</p>
                        </div>
                      </td>
                      <td>$ 255</td>
                    </tr>
                    <tr>
                      <th scope="row">
                        <div>
                          <img src={modalimage2} alt="" className="avatar-sm" />
                        </div>
                      </th>
                      <td>
                        <div>
                          <h5 className="text-truncate font-size-14">
                            Hoodie (Blue)
                          </h5>
                          <p className="text-muted mb-0">$ 145 x 1</p>
                        </div>
                      </td>
                      <td>$ 145</td>
                    </tr>
                    <tr>
                      <td colSpan="2">
                        <h6 className="m-0 text-right">Sub Total:</h6>
                      </td>
                      <td>$ 400</td>
                    </tr>
                    <tr>
                      <td colSpan="2">
                        <h6 className="m-0 text-right">Shipping:</h6>
                      </td>
                      <td>Free</td>
                    </tr>
                    <tr>
                      <td colSpan="2">
                        <h6 className="m-0 text-right">Total:</h6>
                      </td>
                      <td>$ 400</td>
                    </tr>
                  </tbody>
                </Table>
              </div>
            </ModalBody>
            <ModalFooter>
              <Button
                type="button"
                color="secondary"
                onClick={this.togglemodal}
              >
                Close
              </Button>
            </ModalFooter>
          </div>
        </Modal>
      </React.Fragment>
    );
  }
}

Dashboard.propTypes = {
  t: PropTypes.any,
  chartsData: PropTypes.any,
  onGetChartsData: PropTypes.func,
};

const mapStateToProps = ({ Dashboard }) => ({
  chartsData: Dashboard.chartsData,
});

const mapDispatchToProps = dispatch => ({
  onGetChartsData: periodType => dispatch(getChartsData(periodType)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(Dashboard));
